// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg[data-v-16c96742]{transition:transform .2s ease-in-out}svg[data-v-16c96742]:hover{transform:scale(1.1)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
